<!--
 * @Author: GYqwliao liaoqiaowen@thinktrader.net
 * @Date: 2023-03-20 13:43:34
 * @LastEditors: GYqwliao liaoqiaowen@thinktrader.net
 * @LastEditTime: 2023-03-20 14:08:48
 * @FilePath: \crm-questionnaire-ui\src\pages\questionnaire2023\client\refuseInvitation.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="refuseInvitation defatult-bg">
    <div class="text">
      <template v-if="status">
        感谢您对高毅资产的信任和支持，<br />我们期待您的莅临！
      </template>
      <template v-else>
        感谢您对高毅资产的信任和支持！
      </template>
    </div>
    <footer-message style="color: #fff;"></footer-message>
  </div>
</template>

<script>
import footerMessage from '@/components/footer-message'
import {Shares} from '@/util/Share'


export default {
  name: "refuseInvitation",
  data () {
    return {
      status: ""
    }
  },
  mounted () {
    Shares.shareCode()
    this.status = this.$route.query.status || ""
  },
  components: {
    'footer-message': footerMessage
  }
}
</script>

<style lang="less">
.refuseInvitation {
  height: 100vh !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 46px;
  box-sizing: border-box;

  .text {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
